import React, { useState } from 'react';
import { ChevronDown, ExternalLink } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import { useFriendsConfig } from '../hooks/useFriendsConfig';

interface FriendsMenuProps {
  className?: string;
  isMobile?: boolean;
}

const FriendsMenu: React.FC<FriendsMenuProps> = ({ className = '', isMobile = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const { friends, loading } = useFriendsConfig();

  // Non mostrare il menu se non ci sono amici o se sta caricando
  if (loading || friends.length === 0) {
    return null;
  }

  const handleFriendClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center transition-colors duration-200 ${
          isMobile 
            ? 'hover:text-pink-200 w-full text-left py-2'
            : 'text-white hover:text-pink-200'
        }`}
        aria-label={t('header.friendsLink')}
      >
        {t('header.friendsLink')}
        <ChevronDown 
          className={`ml-1 h-4 w-4 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`} 
        />
      </button>

      {isOpen && (
        <>
          {/* Overlay per chiudere il dropdown su desktop */}
          {!isMobile && (
            <div 
              className="fixed inset-0 z-40" 
              onClick={() => setIsOpen(false)}
            />
          )}
          
          {/* Dropdown menu */}
          <div className={`${
            isMobile 
              ? 'mt-2 ml-4 space-y-2' 
              : 'absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50 py-2'
          }`}>
            {friends.map((friend) => (
              <button
                key={friend.id}
                onClick={() => handleFriendClick(friend.url)}
                className={`${
                  isMobile
                    ? 'block hover:text-pink-200 text-sm py-1'
                    : 'w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center justify-between'
                }`}
                title={friend.description}
              >
                <span>{friend.name}</span>
                {!isMobile && <ExternalLink className="h-3 w-3 text-gray-400" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default FriendsMenu;